import React, { Component } from 'react';
import { Bar, Line } from 'react-chartjs-2';
import Select from 'react-select'
import ShopStat from './stats/ShopStat';
import CardPage from '../../../commonModules/layouts/CardPage';
import { InputSelect } from '../../../commonModules/interface/form-input-inline';

const Months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
let oneDayTS = 24 * 60 * 60 * 1000

class Stats extends Component {
    state = { 
        view: "Months",
        customPeriod: 0,
        shop: {value: "", label:""},
        shopID: ""
    }
    createShopList(){
        const list = [{value:"", label:"Tous les Magasins"}]
        const { SHOPS } = this.props
        if( SHOPS ){
            Object.values(SHOPS).map( shop => { 
                list.push(       
                    {value:shop.id, label:shop.name} 
                )
            })
        } 

        return list
    }
    handleSelect = (option) => {
        console.log("SELECT HANDLE",{option});
        this.setState({
            shop: option,
            shopID: option.value
        })
    }

    render() {
        const { SALES, PURCHASES, SHOPS } = this.props;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        const shops = this.createShopList()
        return (
            <CardPage  storehouse>
                <InputSelect
                    options={shops}
                    value={this.state.shop}
                    onChange={ option => this.handleSelect(option)}
                />
                <ShopStat shop={this.state.shopID} {...this.props} />
            </CardPage>
        );
    }
}

export default Stats;